import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { DialogActions, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DeleteConfirmDialog(props) {
    const open = props.open;
    const itemToDelete = props.itemToDelete;
    const customMessage = props.customMessage;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const [deleting, setDeleting] = useState(false);

    // Reset deleting state when dialog opens/closes
    useEffect(() => {
        if (!open) {
            setDeleting(false);
        }
    }, [open]);

    const close = () => {
        if (!deleting) {
            props.cancel();
        }
    };
    const deleteConfirm = () => {
        if (!deleting) {
            setDeleting(true);
            props.confirmDelete();
        }
    };

    return (
        <Dialog
            onClose={close}
            aria-labelledby="simple-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <DialogTitle>{t('general.confirmRemoveTitle')}</DialogTitle>
            <DialogContent dividers>
                <br />
                <span>
                    {customMessage ? (
                        customMessage
                    ) : (
                        <>
                            {t('general.confirmRemove')} <strong>{itemToDelete}</strong>?
                        </>
                    )}
                </span>
                <br />
            </DialogContent>
            <DialogActions>
                <Button
                    name="dialog-btn-locationedit-remove"
                    variant="contained"
                    color="primary"
                    onClick={deleteConfirm}
                    disabled={deleting}>
                    {t('buttons.remove')}
                </Button>
                <Button
                    name="dialog-btn-locationedit-cancel-remove"
                    variant="contained"
                    onClick={close}
                    disabled={deleting}>
                    {t('buttons.cancel')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
